import { StyleSheet, ScrollView, View, Pressable, Switch, Platform, Linking } from "react-native";
import { useSafeAreaInsets } from "react-native-safe-area-context";
import { BasePage } from "./helpers/BasePage";
import { PlaceColors } from "./helpers/PlaceColors";
import CountryFlag from "react-native-country-flag";
import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { FindifyDataContext, FindifyDataContextType } from "@/contexts/FindifyDataContext";
import { FindifyBasicModal } from "./components/FindifyBasicModal";
import { PlaceText } from "./components/PlaceText";
import Icon from "react-native-vector-icons/Ionicons";
import { getTranslatedString } from "./helpers/FindifyTranslatedString";
import InAppReview from 'react-native-in-app-review';
import { FindifySimpleHeader } from "./components/FindifySimpleHeader";
import { useForm } from "react-hook-form";
import { FindifyInputRenderer, FindifyInputRendererType } from "./helpers/FindifyInputRender";
import { FindifyToast } from "./components/FindifyToast";
import { getApiFromModule } from "./helpers/GetContentsByModule";
import { navigateToBottomBar } from "./components/FindifyNavigation";
import Config from "react-native-config";


const ProfileHeader = ({ navigation, availableLanguages, isLogged }: any) => {
    const findifyDataContext = useContext(FindifyDataContext);
    const insets = useSafeAreaInsets();
    const [loginModalOpen, setLoginModalOpen] = useState(false);
    const [passwordResetModalOpen, setPasswordResetModalOpen] = useState(false);
    const [signupModalOpen, setSignupModalOpen] = useState(false);
    const { t } = useTranslation();



    const loginButtonStyle = {
        padding: 3,
        backgroundColor: PlaceColors(findifyDataContext).background.get(),
        color: PlaceColors(findifyDataContext).text.get(),
        borderRadius: 15,
        paddingHorizontal: 10,
        marginTop: 10
    }

    return <>
        <FindifySimpleHeader
            isEventLayout
            backgroundColor={PlaceColors(findifyDataContext).alternateListBG.get()}
            navigation={navigation} />
        {!Config.WORKSPACE_ID &&
            <View style={{
                backgroundColor: PlaceColors(findifyDataContext).alternateListBG.get(),
                paddingBottom: 20,
                width: '100%',
                zIndex: 1,
                display: 'flex',
                flexDirection: 'column',
                gap: -30
            }}>

                <View style={{ gap: 10, display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                    <Icon name="person-circle-outline" size={140} color={PlaceColors(findifyDataContext).text.get()} />
                    <View style={{ flex: 1 }} >
                        <PlaceText style={{ color: PlaceColors(findifyDataContext).text.get(), fontSize: 20, }}>
                            {findifyDataContext?.userCustomerAccounts[findifyDataContext.workspace.workspace_id]?.email}
                        </PlaceText>
                    </View>
                </View>
                <LoginModal
                    loginModalOpen={loginModalOpen}
                    setLoginModalOpen={setLoginModalOpen}
                    passwordResetModalOpen={passwordResetModalOpen}
                    setPasswordResetModalOpen={setPasswordResetModalOpen}
                />
                <PasswordResetModal
                    passwordResetModalOpen={passwordResetModalOpen}
                    setPasswordResetModalOpen={setPasswordResetModalOpen}
                />
                <SignUpModal
                    signupModalOpen={signupModalOpen}
                    setSignupModalOpen={setSignupModalOpen}
                    availableLanguages={availableLanguages}
                />
                <View
                    style={{
                        display: 'flex',
                        alignItems: 'flex-end',
                        flexDirection: 'column',
                        marginLeft: 'auto',
                        marginRight: 20,
                        marginTop: 0,
                        paddingTop: 0,
                    }}
                >
                    <Pressable style={[loginButtonStyle, {}]} onPress={() => navigation.navigate('AdminZone')}><PlaceText style={{ color: PlaceColors(findifyDataContext).text.get() }}>{t('base.admin.admin_zone')}</PlaceText></Pressable>
                    <View
                        style={{
                            flexDirection: 'row',
                            gap: 10
                        }}
                    >
                        {isLogged && <Pressable style={[loginButtonStyle, {}]} onPress={() => {
                            findifyDataContext.setUserCustomerAccounts({
                                ...findifyDataContext.userCustomerAccounts,
                                [findifyDataContext.workspace.workspace_id]: undefined
                            })
                        }}><PlaceText style={{ color: PlaceColors(findifyDataContext).text.get() }}>{t('profile_tab.login.logout')}</PlaceText></Pressable>}
                        {!isLogged &&
                            <>
                                <Pressable style={[loginButtonStyle, {}]} onPress={() => setLoginModalOpen(true)}><PlaceText style={{ color: PlaceColors(findifyDataContext).text.get() }}>{t('profile_tab.login.login')}</PlaceText></Pressable>
                                <Pressable style={[loginButtonStyle, {}]} onPress={() => setSignupModalOpen(true)}><PlaceText style={{ color: PlaceColors(findifyDataContext).text.get() }}>{t('profile_tab.login.create_account')}</PlaceText></Pressable>
                            </>}
                    </View>
                </View>
            </View >
        }
    </>
}

export const ProfileTab = ({ navigation }: any) => {
    const insets = useSafeAreaInsets();
    const { t } = useTranslation();
    const findifyDataContext = useContext(FindifyDataContext);
    const [languagesModalOpen, setLanguagesModalOpen] = useState(false);
    const [ageModalOpen, setAgeModalOpen] = useState(false);
    const availableLanguages: any[] = findifyDataContext?.workspace?.languages ?? [];
    const availableAges = [
        { label: t('profile_tab.child'), value: 'child' },
        { label: t('profile_tab.adult'), value: 'adult' },
    ];

    const [isLogged, setIsLogged] = useState(false);
    useEffect(() => {
        if (findifyDataContext?.userCustomerAccounts[findifyDataContext.workspace.workspace_id]) {
            setIsLogged(true);
        } else {
            setIsLogged(false);
        }
    }, [findifyDataContext?.userCustomerAccounts]);


    return (<BasePage navigation={navigation}>
        {/* <FindifyTopBarOverlay /> */}
        <ScrollView
            bounces={false}
            showsHorizontalScrollIndicator={false}
            showsVerticalScrollIndicator={false}
            style={{
                backgroundColor: PlaceColors(findifyDataContext).background.get()
            }}
        >
            <ProfileHeader navigation={navigation} availableLanguages={availableLanguages} isLogged={isLogged} />
            <View style={{ ...styles.optionsZone, paddingTop: insets.top + 10, }}>
                <PlaceText style={[
                    styles.optionsZoneTitle,
                    {
                        color: findifyDataContext.darkMode ? PlaceColors(findifyDataContext).text.get() : PlaceColors(findifyDataContext).primary.get()
                    }]}>{t('profile_tab.settings')}</PlaceText>
                <View style={styles.optionsZoneOption}>
                    <PlaceText style={[styles.optionsZoneOptionText, { color: PlaceColors(findifyDataContext).text.get() }]}>{t('profile_tab.language')}</PlaceText>
                    <Pressable onPress={() => setLanguagesModalOpen(true)}>
                        <View style={[styles.optionsZoneOptionBG, { backgroundColor: PlaceColors(findifyDataContext).text.withAlpha(30) }]} >
                            {/* <CountryFlag isoCode={'pt-PT'.split('-')[1]} size={0} style={styles.flags} /> */}
                            <CountryFlag isoCode={findifyDataContext?.language?.split('-')[1] ?? ''} size={0} style={styles.flags} />
                        </View>
                    </Pressable>
                    <FindifyBasicModal
                        isOpen={languagesModalOpen}
                        closeModal={() => {
                            setLanguagesModalOpen(false)
                        }}
                    >
                        <View style={styles.optionsZoneOptionsModal}>
                            {availableLanguages.map((lang: any, index: number) => {
                                return <Pressable
                                    key={'avaliableLanguages' + index}
                                    onPress={() => {
                                        findifyDataContext?.setLanguage(lang?.language?.tag);
                                        setLanguagesModalOpen(false);
                                    }}>
                                    <View style={{ ...styles.optionsZoneOptionModalLine, ...(index !== 0 ? [styles.optionTopBorder, { borderTopColor: PlaceColors(findifyDataContext).text.withAlpha(100) }] : {}) }}>
                                        <PlaceText>{lang?.language?.local}</PlaceText>
                                        <CountryFlag isoCode={lang?.language?.tag?.split('-')[1] ?? ''} size={0} style={styles.flags} />
                                    </View>
                                </Pressable>
                            })}
                        </View>
                    </FindifyBasicModal>
                </View>
                {!Config.WORKSPACE_ID && <View style={styles.optionsZoneOption}>
                    <PlaceText style={[styles.optionsZoneOptionText, { color: PlaceColors(findifyDataContext).text.get() }]}>{t('profile_tab.age')}</PlaceText>
                    <Pressable onPress={() => setAgeModalOpen(true)}>
                        <View style={[styles.optionsZoneOptionBG, { backgroundColor: PlaceColors(findifyDataContext).text.withAlpha(30) }]}>
                            <PlaceText style={{ ...styles.optionsZoneOptionLink, color: PlaceColors(findifyDataContext).text.get(), fontSize: 14 }}>{t('profile_tab.' + findifyDataContext?.age)}</PlaceText>
                        </View>
                    </Pressable>
                    <FindifyBasicModal
                        isOpen={ageModalOpen}
                        closeModal={() => {
                            setAgeModalOpen(false)
                        }}
                    >
                        <View style={styles.optionsZoneOptionsModal}>
                            {availableAges.map((age: any, index: number) => {
                                return <Pressable
                                    key={'avaliableAges' + index}
                                    onPress={() => {
                                        setAgeModalOpen(false);
                                        findifyDataContext?.setAge(age.value);
                                    }}>
                                    <View style={{ ...styles.optionsZoneOptionModalLine, ...(index !== 0 ? [styles.optionTopBorder, { borderTopColor: PlaceColors(findifyDataContext).text.withAlpha(100) }] : {}) }}>
                                        <PlaceText style={{ ...styles.optionsZoneOptionLink, color: PlaceColors(findifyDataContext).text.get(), fontSize: 14 }}>{t('profile_tab.' + age.value)}</PlaceText>
                                    </View>
                                </Pressable>
                            })}
                        </View>
                    </FindifyBasicModal>

                </View>}

                {/* AudioGuide */}
                {

                    findifyDataContext?.workspace?.app_settings?.enable_audioguide === true &&
                    <View style={styles.optionsZoneOption}>
                        <PlaceText style={[styles.optionsZoneOptionText, { color: PlaceColors(findifyDataContext).text.get() }]}>{t('profile_tab.audio_guide')}</PlaceText>
                        <Switch
                            trackColor={{
                                // false: PlaceColors(findifyDataContext).text.withAlpha(100),
                                true: PlaceColors(findifyDataContext).text.withAlpha(30)
                            }}
                            thumbColor={PlaceColors(findifyDataContext).text.get()}
                            style={styles.switch}
                            onValueChange={() => {
                                findifyDataContext?.setAudioGuide(!findifyDataContext?.audioGuide)
                            }}
                            value={findifyDataContext?.audioGuide}
                        />
                    </View>
                }
                {
                    findifyDataContext?.workspace?.app_settings?.enable_darkmode === true &&
                    <View style={styles.optionsZoneOption}>
                        <PlaceText style={[styles.optionsZoneOptionText, { color: PlaceColors(findifyDataContext).text.get() }]}>{t('profile_tab.dark_mode')}</PlaceText>
                        <Switch
                            trackColor={{
                                // false: PlaceColors(findifyDataContext).text.withAlpha(100),
                                true: PlaceColors(findifyDataContext).text.withAlpha(30)
                            }}
                            thumbColor={PlaceColors(findifyDataContext).text.get()}
                            style={styles.switch}
                            // ios_backgroundColor="#3e3e3e"
                            onValueChange={() => {
                                findifyDataContext?.setDarkMode(!findifyDataContext?.darkMode)
                            }}
                            value={findifyDataContext?.darkMode}
                        />
                    </View>
                }
                <View style={[styles.optionsZoneDivider, { backgroundColor: PlaceColors(findifyDataContext).text.withAlpha(100) }]}></View>
            </View>
            {/* OFFLIEN ZONE */}
            {/* <View style={{ ...styles.optionsZone }}>
                <View style={styles.optionsZoneOption}>
                    <PlaceText style={[styles.optionsZoneTitle, {color: PlaceColors(findifyDataContext).primary.get(),}]}>{t('profile_tab.offline_data')}</PlaceText>
                    <PlaceText style={[styles.optionsZoneOptionLink, {color: PlaceColors(findifyDataContext).primary.get(),}]}>{t('profile_tab.view_all')}</PlaceText>
                </View>
                <View style={styles.optionsZoneOption}>
                    <PlaceText style={[styles.optionsZoneOptionText, {color: PlaceColors(findifyDataContext).text.get()}]}>{t('profile_tab.delete_all_offline_data')}</PlaceText>
                    <Icon name="trash-outline" size={20} color={PlaceColors(findifyDataContext).primary.get()} />
                </View>
                <View style={[styles.optionsZoneDivider, {backgroundColor: PlaceColors(findifyDataContext).text.withAlpha(100)}]}></View>
            </View> */}
            <View style={{ ...styles.optionsZone }}>
                {(findifyDataContext.favouriteWorkspaces && findifyDataContext.favouriteWorkspaces.length > 0) && <>
                    <View style={styles.optionsZoneOption}>
                        <PlaceText style={[styles.optionsZoneOptionText, { color: PlaceColors(findifyDataContext).text.get() }]}>{t('profile_tab.favourites')}</PlaceText>
                        <PlaceText style={[styles.optionsZoneOptionLink, { color: PlaceColors(findifyDataContext).text.get(), }]}>{t('profile_tab.view')}</PlaceText>
                    </View>
                    <View style={{}}>
                        {findifyDataContext.favouriteWorkspaces.map((workspace: any, index: number) => {
                            return <View style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                flexDirection: 'row',
                                paddingVertical: 6,
                                borderTopWidth: 1,
                                borderTopColor: PlaceColors(findifyDataContext).text.withAlpha(100),
                                // marginBottom: 10
                            }}>
                                <PlaceText style={{ color: PlaceColors(findifyDataContext).text.get() }} > {getTranslatedString(findifyDataContext.availableWorkspaces.find((w: any) => w.workspace_id === workspace)?.name, findifyDataContext)}</PlaceText>
                                <Icon name="trash-outline" size={20} color={PlaceColors(findifyDataContext).primary.get()} onPress={() => {
                                    findifyDataContext?.setFavouriteWorkspaces(findifyDataContext?.favouriteWorkspaces.filter((id) => id !== workspace));

                                }} />
                            </View>

                        })}
                    </View>
                    <View style={[styles.optionsZoneDivider, { backgroundColor: PlaceColors(findifyDataContext).text.withAlpha(100) }]}></View>
                </>
                }
                {/* 
                <View style={styles.optionsZoneOption}>
                <PlaceText style={[styles.optionsZoneOptionText, {color: PlaceColors(findifyDataContext).text.get()}]}>{t('profile_tab.your_donations')}</PlaceText>
                <PlaceText style={[styles.optionsZoneOptionLink, {color: PlaceColors(findifyDataContext).primary.get(),}]}>{t('profile_tab.view')}</PlaceText>
                </View>
            */}
                {/* 
                <View style={styles.optionsZoneOption}>
                <PlaceText style={[styles.optionsZoneOptionText, {color: PlaceColors(findifyDataContext).text.get()}]}>{t('profile_tab.your_cart')}</PlaceText>
                <PlaceText style={[styles.optionsZoneOptionLink, {color: PlaceColors(findifyDataContext).primary.get(),}]}>{t('profile_tab.view')}</PlaceText>
                </View>
                <View style={[styles.optionsZoneDivider, { backgroundColor: PlaceColors(findifyDataContext).text.withAlpha(100) }]}></View>
                */}
                {/* TODO RATE  */}

                {/* <View style={{ ...styles.rateApp }}>
                    <PlaceText style={[styles.rateAppText, { color: PlaceColors(findifyDataContext).text.get() }]}>{t('profile_tab.rate_this_app')}</PlaceText>
                    <Pressable onPress={() => {
                        console.log('can rev', InAppReview.isAvailable());
                        // trigger UI InAppreview
                        InAppReview.RequestInAppReview()
                            .then((hasFlowFinishedSuccessfully) => {
                                // // when return true in android it means user finished or close review flow
                                // console.log('InAppReview in android', hasFlowFinishedSuccessfully);

                                // // when return true in ios it means review flow lanuched to user.
                                // console.log(
                                //     'InAppReview in ios has launched successfully',
                                //     hasFlowFinishedSuccessfully,
                                // );

                                // // 3- another option:
                                // if (hasFlowFinishedSuccessfully) {
                                //     // do something for ios
                                //     // do something for android
                                // }
                            })
                            .catch((error) => {
                                // console.log(error);
                            });
                        if (Platform.OS === 'android') {
                            // Android
                            const packageName = 'peakit.findify.app'; // Replace with your app's package name
                            const url = `market://details?id=${packageName}`;
                            Linking.openURL(url).catch(err => {
                                console.log(err);
                            });
                        } else if (Platform.OS === 'ios') {
                            // iOS
                            const appId = '1579708700'; // Replace with your app's App Store ID
                            const url = `itms-apps://itunes.apple.com/app/id${appId}`;
                            Linking.openURL(url).catch(err => {
                                console.log(err);
                            });
                        }

                    }}>
                        <View style={[styles.rateAppButton, {
                            backgroundColor: PlaceColors(findifyDataContext).text.get(),
                        }]}>
                            <PlaceText style={[
                                styles.rateAppButtonText,
                                {
                                    color: PlaceColors(findifyDataContext).background.get(),
                                }

                            ]}>{t('profile_tab.rate_button')}</PlaceText>
                        </View>
                    </Pressable>
                </View> */}
                {isLogged &&
                    <View style={{ ...styles.rateApp, paddingBottom: insets.bottom }}>
                        <Pressable onPress={() => {
                            navigation.navigate('UserTickets');
                        }}>
                            <View style={[styles.rateAppButton, {
                                backgroundColor: PlaceColors(findifyDataContext).text.get(),
                            }]}>
                                <PlaceText style={[
                                    styles.rateAppButtonText,
                                    {
                                        color: PlaceColors(findifyDataContext).background.get(),
                                    }

                                ]}>{t('profile_tab.view_tickets')}</PlaceText>
                            </View>
                        </Pressable>
                    </View>
                }
                {isLogged &&
                    <View style={{ ...styles.rateApp, paddingBottom: insets.bottom }}>
                        <Pressable onPress={() => {
                            navigation.navigate('UserOrders');
                        }}>
                            <View style={[styles.rateAppButton, {
                                backgroundColor: PlaceColors(findifyDataContext).text.get(),
                            }]}>
                                <PlaceText style={[
                                    styles.rateAppButtonText,
                                    {
                                        color: PlaceColors(findifyDataContext).background.get(),
                                    }

                                ]}>{t('profile_tab.view_orders')}</PlaceText>
                            </View>
                        </Pressable>
                    </View>
                }
                {!Config.WORKSPACE_ID &&
                    <View style={{ ...styles.rateApp, paddingBottom: insets.bottom + styles.rateApp.paddingTop + 55 }}>
                        <Pressable onPress={() => findifyDataContext?.setVisitWorkspaceSelected(false)}>
                            <View style={[styles.rateAppButton, {
                                backgroundColor: PlaceColors(findifyDataContext).text.get(),
                            }]}>
                                <PlaceText style={[
                                    styles.rateAppButtonText,
                                    {
                                        color: PlaceColors(findifyDataContext).background.get(),
                                    }

                                ]}>{t('profile_tab.change_place')}</PlaceText>
                            </View>
                        </Pressable>
                    </View>
                }
            </View>
        </ScrollView >
    </BasePage >);
};

const LoginModal = ({
    loginModalOpen,
    setLoginModalOpen,
    passwordResetModalOpen,
    setPasswordResetModalOpen
}: {
    loginModalOpen: boolean,
    setLoginModalOpen: any,
    passwordResetModalOpen: boolean
    setPasswordResetModalOpen: any,
}) => {
    const findifyDataContext = useContext(FindifyDataContext);
    const { t } = useTranslation();
    const form = useForm();
    const authenticationApi = getApiFromModule('authentication', findifyDataContext);

    const fields = [
        {
            label: t('profile_tab.login.email'),
            fieldKey: 'email',
            type: FindifyInputRendererType.Text,
            textContentType: "emailAddress",
            validate: {
                minLength: (v: string) => v?.length ?? 0 >= 3,
                maxLength: (v: string) => v?.length ?? 0 <= 250, //  "The email should have at most 50 characters",
                invalidEmail: (v: string) => /\S+@\S+\.\S+/.test(v ?? ''), //  "Email address must be a valid address",
            },
            required: true
        },
        {
            label: t('profile_tab.login.password'),
            fieldKey: 'password',
            textContentType: "password",
            validate: {
                minLength: (v: string) => v?.length ?? 0 >= 3
            },
            type: FindifyInputRendererType.Text,
            required: true
        },
    ]

    const actions = [
        {
            onPress: async () => {
                const valid = await form.trigger();
                if (valid) {
                    const data = form.getValues();
                    authenticationApi.login({
                        email: data.email,
                        password: data.password
                    }).then((res: any) => {
                        // Save Credentials based on workspace
                        findifyDataContext.setUserCustomerAccounts({
                            ...findifyDataContext.userCustomerAccounts,
                            [findifyDataContext.workspace.workspace_id]: res,
                        });
                        setLoginModalOpen(false);
                        FindifyToast({ type: 'success', title: t('profile_tab.login.login_successful') });
                    }).catch((err: any) => {
                        // Warn about invalid data
                        FindifyToast({ type: 'error', title: t('profile_tab.login.invalid_credentials') });
                    });
                }
            },
            label: t('profile_tab.login.login')
        },
        {
            onPress: () => {
                setLoginModalOpen(false);
                setPasswordResetModalOpen(true);
            },
            label: t('profile_tab.login.forgot_password')
        }
    ];

    return <ProfileFormModal
        fields={fields}
        isOpen={loginModalOpen}
        setIsOpen={setLoginModalOpen}
        findifyDataContext={findifyDataContext}
        label={t('profile_tab.login.login')}
        form={form}
        t={t}
        actions={actions}
    />;
}

const SignUpModal = ({
    signupModalOpen,
    setSignupModalOpen,
    availableLanguages
}: {
    signupModalOpen: boolean
    setSignupModalOpen: any,
    availableLanguages: any
}) => {
    const findifyDataContext = useContext(FindifyDataContext);
    const { t } = useTranslation();
    const form = useForm();
    const authenticationApi = getApiFromModule('authentication', findifyDataContext);

    const fields = [
        {
            label: t('profile_tab.login.email'),
            fieldKey: 'email',
            type: FindifyInputRendererType.Text,
            textContentType: "emailAddress",
            validate: {
                minLength: (v: string) => v?.length ?? 0 >= 3,
                maxLength: (v: string) => v?.length ?? 0 <= 250, //  "The email should have at most 50 characters",
                invalidEmail: (v: string) => /\S+@\S+\.\S+/.test(v ?? ''), //  "Email address must be a valid address",
            },
            required: true
        },
        {
            label: t('profile_tab.login.password'),
            fieldKey: 'password',
            textContentType: "password",
            validate: {
                minLength: (v: string) => v?.length ?? 0 >= 3
            },
            type: FindifyInputRendererType.Text,
            required: true
        },
        {
            label: t('profile_tab.login.password_confirmation'),
            fieldKey: 'password_confirmation',
            textContentType: "password",
            validate: {
                minLength: (v: string) => v?.length ?? 0 >= 3
            },
            type: FindifyInputRendererType.Text,
            required: true
        },
        {
            label: t('profile_tab.login.language'),
            fieldKey: 'language',
            type: FindifyInputRendererType.Dropdown,
            dropdownData: availableLanguages.map((l: any) => ({ label: l.language?.local, value: l.language?.tag })),
            dropdownSearch: false,
            required: true
        },

    ]

    const actions = [{
        onPress: async () => {
            const valid = await form.trigger();
            if (valid) {
                const data = form.getValues();
                authenticationApi.signup({
                    email: data.email,
                    password: data.password,
                    password_confirmation: data.password_confirmation,
                    language: data.language,
                }).then((res: any) => {
                    setSignupModalOpen(false);
                    FindifyToast({
                        type: 'success',
                        title: t('profile_tab.login.signup_sucessful'),
                        message: t("profile_tab.login.signup_sucessful_check_email")
                    });
                }).catch((err: any) => {
                    // Warn about invalid data
                    FindifyToast({
                        type: 'error',
                        title: t('profile_tab.login.signup_error')
                    });
                });
            }
        },
        label: t('profile_tab.login.register')
    }];

    return <ProfileFormModal
        fields={fields}
        isOpen={signupModalOpen}
        setIsOpen={setSignupModalOpen}
        findifyDataContext={findifyDataContext}
        label={t('profile_tab.login.create_account')}
        form={form}
        t={t}
        actions={actions}
    />;
}

const PasswordResetModal = ({
    passwordResetModalOpen,
    setPasswordResetModalOpen
}: {
    passwordResetModalOpen: boolean
    setPasswordResetModalOpen: any,
}) => {
    const findifyDataContext = useContext(FindifyDataContext);
    const { t } = useTranslation();
    const form = useForm();
    const authenticationApi = getApiFromModule('authentication', findifyDataContext);

    const fields = [
        {
            label: t('profile_tab.login.email'),
            fieldKey: 'email',
            type: FindifyInputRendererType.Text,
            textContentType: "emailAddress",
            validate: {
                minLength: (v: string) => v?.length ?? 0 >= 3,
                maxLength: (v: string) => v?.length ?? 0 <= 250, //  "The email should have at most 50 characters",
                invalidEmail: (v: string) => /\S+@\S+\.\S+/.test(v ?? ''), //  "Email address must be a valid address",
            },
            required: true
        },

        {
            label: t('profile_tab.login.email_confirmation'),
            fieldKey: 'email_confirmation',
            type: FindifyInputRendererType.Text,
            textContentType: "emailAddress",
            validate: {
                minLength: (v: string) => v?.length ?? 0 >= 3,
                maxLength: (v: string) => v?.length ?? 0 <= 250, //  "The email should have at most 50 characters",
                invalidEmail: (v: string) => /\S+@\S+\.\S+/.test(v ?? ''), //  "Email address must be a valid address",
                sameAsEmail: (value: string) => value === form.getValues("email")
            },
            required: true
        },

    ]

    const actions = [{
        onPress: async () => {
            const valid = await form.trigger();
            if (valid) {
                const data = form.getValues();
                authenticationApi.forgotPassword({
                    email: data.email,
                    email_confirmation: data.email_confirmation,
                }).then((res: any) => {
                    setPasswordResetModalOpen(false);
                    FindifyToast({
                        type: 'success',
                        title: t('profile_tab.login.password_reset_requested'),
                        message: t("profile_tab.login.password_reset_requested_check_mail")
                    });
                }).catch((err: any) => {
                    // Warn about invalid data
                    FindifyToast({
                        type: 'error',
                        title: t('profile_tab.login.password_reset_request_error')
                    });
                });
            }
        },
        label: t('profile_tab.login.reset')
    }];

    return <ProfileFormModal
        fields={fields}
        isOpen={passwordResetModalOpen}
        setIsOpen={setPasswordResetModalOpen}
        findifyDataContext={findifyDataContext}
        label={t('profile_tab.login.reset_password')}
        form={form}
        t={t}
        actions={actions}
    />;
}


export const ProfileFormModal = ({
    fields,
    isOpen,
    setIsOpen,
    findifyDataContext,
    label,
    form,
    t,
    actions,
}: {
    fields: any[],
    isOpen: boolean,
    setIsOpen: Function,
    findifyDataContext: FindifyDataContextType,
    label: string,
    form: any,
    t: any,
    actions: { onPress: any, label: string }[]
}) => {

    return <FindifyBasicModal
        isOpen={isOpen}
        transparent={true}
        // align="flex-end"
        closeModal={() => setIsOpen(false)}
    >
        <View style={[{
            // marginBottom: insets.bottom + 75, 
            backgroundColor: PlaceColors(findifyDataContext).background.get(),
            padding: 20,
            borderRadius: 10,
            minWidth: '80%'
        }]}>
            <PlaceText style={{ color: PlaceColors(findifyDataContext).text.get(), fontWeight: 'bold', fontSize: 20 }}>{label}</PlaceText>
            {fields.map((feildsd: any) => {
                return <FindifyInputRenderer
                    style={{}}
                    findifyDataContext={findifyDataContext}
                    form={form}
                    t={t}
                    fieldData={feildsd}
                />
            })}
            <View
                style={{
                    flexDirection: 'row',
                    justifyContent: 'space-between'
                }}
            >
                {actions.map((action: any) => {
                    return <Pressable style={{
                        marginTop: 10,
                        backgroundColor: PlaceColors(findifyDataContext).text.get(),
                        padding: 5,
                        borderRadius: 10
                    }}
                        onPress={action.onPress}
                    >
                        <PlaceText
                            style={{
                                color: PlaceColors(findifyDataContext).background.get(),
                            }}
                        >
                            {action.label}
                        </PlaceText>
                    </Pressable>
                })}
            </View>
        </View>
    </FindifyBasicModal>
}


const styles = StyleSheet.create({
    flags: {
        width: 20,
        height: 15,
    },
    switch: {
        height: 30
    },
    optionsZone: {
        padding: 10,
        width: '100%',
    },
    optionsZoneTitle: {
        fontSize: 20,
        fontWeight: '500',
        paddingVertical: 5,
    },
    optionsZoneOption: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        paddingVertical: 5,

    },
    optionsZoneOptionText: {
        // color: 'red',
        fontSize: 16,
    },
    optionsZoneOptionLink: {
        fontSize: 16,
    },
    optionsZoneOptionBG: {
        padding: 10,
        borderRadius: 20,
        // backgroundColor: "#00000020",
    },
    optionTopBorder: {
        borderTopWidth: 1
    },
    optionsZoneOptionsModal: {
        zIndex: 100
    },
    optionsZoneOptionModalLine: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        gap: 15,
        padding: 10,
        // width: '90%'

    },
    optionsZoneDivider: {
        width: '80%',
        marginLeft: '10%',
        marginRight: '10%',
        marginTop: 10,
        height: 2,
        borderRadius: 6,
    },
    rateApp: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        paddingTop: 20,

    },
    rateAppText: {
        fontSize: 16,

        marginBottom: 10,
    },
    rateAppButton: {
        fontSize: 16,
        textTransform: 'uppercase',

        padding: 5,
        paddingHorizontal: 20,
        borderRadius: 26,
        // color: PlaceColors(findifyDataContext).primary.get(),
    },
    rateAppButtonText: {
        fontSize: 16,
        color: 'white',
    },
    sectionContainer: {
        marginTop: 32,
        paddingHorizontal: 24,
    },
    sectionTitle: {
        fontSize: 24,
        fontWeight: '600',
    },
    sectionDescription: {
        marginTop: 8,
        fontSize: 18,
        fontWeight: '400',
    },
    highlight: {
        fontWeight: '700',
    },

    container: {
        flex: 1,
    },
    small: {
        width: 200,
        height: 200,
        marginBottom: 10,
        marginRight: 10,
        backgroundColor: 'skyblue',
    },
    large: {
        width: 300,
        height: 300,
        marginBottom: 10,
        marginRight: 10,
        backgroundColor: 'steelblue',
    },
});